import updateGroupCurrentInfoAction from './updateGroupCurrentInfoAction';
import { action, orchestrator } from 'satcheljs';
import { loadGroupInformation } from './loadGroupInformation';
import { isConsumer } from 'owa-session-store';

export const MaxGroupMembersToReturn = 5;

const loadGroupAction = action(
    'loadGroupAction',
    (groupSmtpAddress: string, onLoadGroupSuccess?: () => void, onLoadGroupError?: () => void) => {
        return { groupSmtpAddress, onLoadGroupSuccess, onLoadGroupError };
    }
);

orchestrator(loadGroupAction, msg => {
    const { groupSmtpAddress, onLoadGroupSuccess, onLoadGroupError } = msg;

    loadGroupInformation(
        groupSmtpAddress,
        true, // Load Full Details
        isConsumer() ? null : MaxGroupMembersToReturn, //membersToReturn - For consumer groups we will get all members. We need owner smtp addresses for Report abuse.
        onLoadGroupSuccess,
        onLoadGroupError
    );
    updateGroupCurrentInfoAction(groupSmtpAddress);
});

export default loadGroupAction;
